import slugify from "@sindresorhus/slugify";
import {TOPIC_TYPE_PATHS} from "../../../../paths";

export type TopicMeta = {
    topictypeId: string;
    name: string;
    topicId: string;
};

export const buildCollectionUrl = (
    topicMeta: TopicMeta,
    collection?: {name: string; id: string},
): string => {
    const topicTypePath =
        TOPIC_TYPE_PATHS[
            Number(topicMeta.topictypeId) as keyof typeof TOPIC_TYPE_PATHS
        ] ?? "unknown";
    const base = `/${topicTypePath}/${slugify(topicMeta.name)}/${topicMeta.topicId}`;
    if (!collection) return base;
    return `${base}/utfylling/${slugify(collection.name)}/${collection.id}`;
};
